import { Box, Flex } from '@chakra-ui/layout'

import { LoadScript } from '@react-google-maps/api'

import { Sidebar } from '../components/Sidebar'
import { GoogleMaps } from '../components/GoogleMap'
import { Footer } from '../components/Footer'

import Loading from './Loading'

export default function ParkOffLookForParkingLots() {
  return (
    <LoadScript
      googleMapsApiKey="AIzaSyBNgeb5d3w5EdUk2lqT5WRMyOXTwY4lTrI"
      libraries={['places']}
      authReferrerPolicy="origin"
      loadingElement={<Loading />}
      onError={error => console.log('LoadScript error: ', error)}
    >
      <Box
        // marginLeft={{
        //   base: '20px',
        //   notebook: '71px',
        // }}
        // marginRight={{
        //   base: '20px',
        //   notebook: '71px',
        // }}
        boxSizing="border-box"
        maxWidth="1600px"
      >
        <Box
          display="grid"
          boxSizing="border-box"
          gridTemplateColumns="repeat(12, 1fr)"
          columnGap={{
            base: '16px',
            notebook: '24px',
          }}
        >
          <Box
            gridColumnEnd={{
              base: 'span 12',
            }}
            boxSizing="border-box"
            minWidth="0px"
            minHeight="0px"
          >
            <Box
              background="rgb(255, 255, 255)"
              borderRadius="16px"
              boxShadow="rgb(152 152 166 / 20%) 0px 5px 5px -3px, rgb(152 152 166 / 14%) 0px 8px 10px 1px, rgb(152 152 166 / 12%) 0px 3px 14px 2px"
              // marginBottom={{
              //   base: '32px',
              //   notebook: '40px',
              // }}
              width="100%"
              height={{
                base: '500px',
                notebook: '700px',
              }}
              overflow="hidden"
              position="relative"
            >
              <Flex
                direction={{
                  base: 'column',
                  notebook: 'row',
                }}
                height="100%"
              >
                {/* Filter Sidebar */}
                <Sidebar />
                {/* Google Map */}
                <GoogleMaps />
                {/* Footers */}
                <Footer />
              </Flex>
            </Box>
          </Box>
        </Box>
      </Box>
    </LoadScript>
  )
}
